export const OPPORTUNITY_TYPES = [
  'Full-Time Jobs',
  'Internships',
  'Freelance / Gigs',
  'Contract Roles',
  'Grants',
  'Fellowships',
  'Awards',
  'Volunteer Opportunities',
  'Events & Festivals',
  'Speaking Opportunities',
  'Teaching & Education',
  'Residencies & Open Calls'
];

export const INDUSTRIES = [
  'Art & Galleries',
  'Museums & Heritage',
  'Design',
  'Fashion & Luxury',
  'Architecture & Urbanism',
  'Film, Media & Photography',
  'Performing Arts',
  'Cultural Management & Curation',
  'Education & Research',
  'Events & Experiential',
  'Digital & Creative Tech',
  'Painting & Drawing',
  'Sculpture & Installation',
  'Textiles & Weaving',
  'Murals & Public Art',
  'Ceramics & Pottery',
  'Printmaking',
  'Jewellery & Accessories',
  'Illustration',
  'Calligraphy & Lettering',
  'Craft & Handloom',
  'Animation & Motion Graphics',
  'Photography',
  'Teaching & Art Education'
];

export const SKILL_TAGS = [
  'Curation',
  'Writing & Editing',
  'Marketing & Communications',
  'Social Media & Content',
  'Production & Events',
  'Fundraising & Partnerships',
  'Research',
  'Teaching',
  'Public Speaking',
  'Community Engagement',
  'Painting',
  'Sculpture',
  'Illustration',
  'Photography',
  'Ceramics',
  'Textile Design',
  'Printmaking',
  'Art History',
  'Gallery Management',
  'Exhibition Design',
  'Branding',
  'UX/UI Design',
  'Film Editing',
  'Sound Design',
  'Dance',
  'Music',
  'Theatre',
  'Woodwork',
  'Metal Work',
  'Mural Painting',
  'Weaving',
  'Calligraphy',
  'Animation',
  'Graphic Design',
  'Interior Design',
  'Jewellery Making',
  'Art Restoration'
];
